export const _12PayBanks = [
    {
        label: 'BANGKOK BANK PUBLIC COMPANY LTD',
        code: '002',
        acronym: 'BBL',
    },
    {
        label: 'KASIKORNBANK PUBLIC COMPANY LIMITED',
        code: '004',
        acronym: 'KBANK',
    },
    {
        label: 'KRUNG THAI BANK PUBLIC COMPANY LTD',
        code: '006',
        acronym: 'KTB',
    },
    {
        label: 'TMBTHANACHART BANK PUBLIC COMPANY LTD',
        code: '011',
        acronym: 'TTB',
    },
    {
        label: 'SIAM COMMERCIAL BANK PUBLIC COMPANY LTD',
        code: '014',
        acronym: 'SCB',
    },
    {
        label: 'BANK OF AYUDHYA PUBLIC COMPANY LTD',
        code: '025',
        acronym: 'BAY',
    },
    {
        label: 'KIATNAKIN PHATRA BANK PUBLIC COMPANY LIMITED',
        code: '069',
        acronym: 'KKP',
    },
    {
        label: 'CIMB THAI BANK PUBLIC COMPANY LIMITED',
        code: '022',
        acronym: 'CIMBT',
    },
    {
        label: 'TISCO BANK PUBLIC COMPANY LIMITED',
        code: '067',
        acronym: 'TISCO',
    },
    {
        label: 'UNITED OVERSEAS BANK (THAI) PUBLIC COMPANY LIMITED',
        code: '024',
        acronym: 'UOBT',
    },
    {
        label: 'THE THAI CREDIT RETAIL BANK PUBLIC COMPANY LIMITED',
        code: '071',
        acronym: 'TCD',
    },
    {
        label: 'LAND AND HOUSES BANK PUBLIC COMPANY LIMITED',
        code: '073',
        acronym: 'LHFG',
    },
    {
        label: 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (THAI) PUBLIC COMPANY LTD',
        code: '070',
        acronym: 'ICBCT',
    },
    {
        label: 'SMALL AND MEDIUM ENTERPRISE DEVELOPMENT BANK OF THAILAND',
        code: '098',
        acronym: 'SME',
    },
    {
        label: 'BANK FOR AGRICULTURE AND AGRICULTURAL COOPERATIVES',
        code: '034',
        acronym: 'BAAC',
    },
    {
        label: 'EXPORT-IMPORT BANK OF THAILAND',
        code: '035',
        acronym: 'EXIM',
    },
    {
        label: 'GOVERNMENT SAVINGS BANK',
        code: '030',
        acronym: 'GSB',
    },
    {
        label: 'THE GOVERNMENT HOUSING BANK',
        code: '033',
        acronym: 'GHB',
    },
    {
        label: 'ISLAMIC BANK OF THAILAND',
        code: '066',
        acronym: 'ISBT',
    },
].reduce((obj, kv) => ({ ...obj, [kv.acronym]: { key: kv.acronym, ...kv } }), {});
